var userAgent = navigator.userAgent.toLowerCase();
var isAndroidChrome = /chrome/.test(userAgent) && /android/.test(userAgent);
var isIOSChrome = /crios/.test(userAgent);


var is_chrome = navigator.userAgent.indexOf('Chrome') > -1;
var is_explorer = navigator.userAgent.indexOf('MSIE') > -1;
var is_firefox = navigator.userAgent.indexOf('Firefox') > -1;
var is_safari = navigator.userAgent.indexOf("Safari") > -1;
var is_opera = navigator.userAgent.toLowerCase().indexOf("op") > -1;
if ((is_chrome)&&(is_safari)) { is_safari = false; }
if ((is_chrome)&&(is_opera)) { is_chrome = false; }

// if (is_safari) { alert('Safari'); }
// if (is_opera) { alert('opera'); }
// if (is_explorer) { alert('IE'); }


var ios93 = navigator.userAgent.match(/OS 9_3 like Mac OS X/i);
var iosSafari = navigator.userAgent.match(/OS [0-9]+_[0-9]+ like Mac OS X/i);

var isIOS = /iPad|iPhone|iPod/.test(navigator.platform) || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1)

// console.log(navigator.userAgent);
// console.log('ios93' + ios93);
// console.log('iosSafari' + iosSafari);
// console.log('isAndroidChrome' + isAndroidChrome);
// console.log('isIOSChrome' + isIOSChrome);
// console.log('is_chrome' + is_chrome);

if (isAndroidChrome || isIOSChrome) {    
    $("#app").addClass("vh-fix");
}
else {
    $("#app").addClass("other-browser");
}


if (ios93 || iosSafari || isIOS) {
    $("#contentWrap").addClass("appInnerHeight");
} else {
    $("#appWrap").addClass("h-100");
    $("#contentWrap").addClass("h-100");
}

// alert(ios93);
// alert(navigator.userAgent);

if (ios93 || iosSafari || isIOS) {
    $('.windowInnerHeight').height(window.innerHeight);
    $('.appInnerHeight').height((window.innerHeight) - 69); // Window inner height minus header

    window.onresize=function(){
        //console.log('test' + window.innerHeight);
        $('.windowInnerHeight').height(window.innerHeight);
        $('.appInnerHeight').height((window.innerHeight) - 69); // Window inner height minus header
    }
}


$('.windowInnerHeight').height(window.innerHeight);
$('#contentWrap').height((window.innerHeight) - 57); // Window inner height minus header

function checkHeight() {
    $('.windowInnerHeight').height(window.innerHeight);
}

window.addEventListener('resize', checkHeight);